import { Users, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { trackEmailFocus, trackEmailEntered, trackCTAClick } from '@/lib/analytics';

interface WaitlistSectionProps {
  email: string;
  setEmail: (email: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isSubmitting?: boolean;
}

const WaitlistSection = ({ email, setEmail, handleSubmit, isSubmitting = false }: WaitlistSectionProps) => {
  const formSource = 'homepage_waitlist';

  const handleEmailFocus = () => {
    trackEmailFocus(formSource);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    trackEmailEntered(formSource, newEmail);
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    trackCTAClick(formSource, email);
    handleSubmit(e);
  };

  return (
    <section id="waitlist" className="container mx-auto px-4 py-16 relative z-10">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-blue-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
          <h3 className="text-2xl font-bold text-slate-800 mb-4 flex items-center gap-2 justify-center">
            <Users className="h-6 w-6 text-blue-600" />
            We're mapping the future of small business — want in?
          </h3>
          <p className="text-sm text-slate-600 mb-4 text-center">You set the course. Carto helps you get there.</p>
          <form onSubmit={handleFormSubmit} className="flex gap-4 items-center max-w-2xl mx-auto">
            <Input
              type="email"
              placeholder="trailblazer@yourbusiness.com"
              value={email}
              onChange={handleEmailChange}
              onFocus={handleEmailFocus}
              className="flex-1 border-blue-200 focus:border-blue-400 rounded-xl transition-all duration-300 focus:shadow-lg min-w-0"
              required
              disabled={isSubmitting}
            />
            <Button 
              type="submit" 
              className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Joining...
                </>
              ) : (
                'Join the Waitlist'
              )}
            </Button>
          </form>
          <p className="text-xs text-slate-500 mt-4 text-center">
            Built for busy business owners. No dashboards. No clutter. Just clarity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WaitlistSection;
